
////////////////////////////////////
// M043 quick nav

function initQuickNav(){
    if ($(".quickNav").length > 0) {
	   
		//handle mouse events
        $(".quickNav").mouseover(function(){
            //updateQuickNav();
            $(this).removeClass("open");
            $(this).addClass("open");
        });
        $(".quickNav").mouseout(function(){
            $(this).removeClass("open");
        });
        
        $(".quickNav").find(".quickNavElement").mouseover(function(){
            $(this).find(".circleIcon").removeClass("yacht-blue");
            $(this).find(".circleIcon").removeClass("yacht-yellow");

            $(this).find(".circleIcon").addClass("yacht-yellow");
        });
        $(".quickNav").find(".quickNavElement").mouseout(function(){
            $(this).find(".circleIcon").removeClass("yacht-blue");
            $(this).find(".circleIcon").removeClass("yacht-yellow");
            
            $(this).find(".circleIcon").addClass("yacht-blue");
        });
        //handle focus events
        $(".quickNav").find(".quickNavElement").on("focusout", function(){
            if($(this).parent(".quickNav").hasClass("open")){
                $(this).parent(".quickNav").removeClass("open");
            }
        });
        $(".quickNav").find(".quickNavElement").on("focus", function(){
            if(!$(this).parent(".quickNav").hasClass("open")){
                $(this).parent(".quickNav").addClass("open");
            }
        });
		
		//first update
		updateQuickNav();
		
		//show quicknav delayed
		setTimeout(function(){
			$(".quickNav").removeClass("visible");
			$(".quickNav").addClass("visible");
		}, 500);
    }
}

function updateQuickNav(){
    if ($(".quickNav").length > 0) {

        //consolog("updateQuickNav()");
        
        //equalize element width
        var tw = 0;
        $(".quickNav").find(".quickNavElementTextContainer").css("width", "auto");
        $(".quickNav").find(".quickNavElementTextContainer").each(function(){
            if($(this).width() > tw){
                tw = $(this).width()
            }
        });
        if(tw > 0){
            $(".quickNav").find(".quickNavElementTextContainer").css("width", tw + "px");
            //consolog("updateQuickNav() tw:" + tw);
            $(".quickNav").css("margin-right", -tw + "px");

        }

        $(".quickNav").find(".quickNavElementTextContainer").each(function(){

            $(this).children(".quickNavElementText").css("margin-top", "0px");
            if($(this).children(".quickNavElementText").innerHeight() < $(this).innerHeight()){
                var h = $(this).innerHeight() - $(this).children(".quickNavElementText").innerHeight();
                var m = Math.floor(h/2) - 10;
                if(m > 0){
                    $(this).children(".quickNavElementText").css("margin-top", m + "px");
                }
            }
        });        
    }
}